export const PERMISSION_API_URL = {
  // Kept: used by kept Master Role and notification-setup features
  GET_MASTER_ATTRIBUTE_MODULE_ALL: 'master-module-attribute/all',
  MASTER_ROLE: 'master-role',

  // Master Plan list/export stay on api/v1; plan + feature CRUD go through
  // the V2 master-plan-feature endpoints (single update for plan and flags)
  MASTER_PLAN: 'master-plan',
  GET_MASTER_PLAN_PAGING: 'master-plan/paging',
  GET_MASTER_PLAN_ALL: 'master-plan/all',
  MASTER_PLAN_FEATURE: 'master-plan-feature',
  GET_MASTER_PLAN_FEATURE: 'master-plan-feature/get-plan-feature/{{id}}',
  ADD_ONLY_MASTER_PLAN_FEATURE: 'master-plan-feature/add-only-feature',
  UPDATE_MASTER_PLAN_FEATURE: 'master-plan-feature/update',
  DELETE_MASTER_PLAN_FEATURE: 'master-plan-feature/delete/{{id}}',
  MASTER_ROLE_RIGHT: 'master-role-right',
  MASTER_WIDGET: 'master-widget',
  MASTER_DASHBORD:'master-dashboard',

  MOBILE_VERSION: 'mobile-version',
  GET_MOBILE_VERSION: 'mobile-version/{{id}}',
  GET_MOBILE_VERSION_PAGING: 'mobile-version/paging',
  GET_MOBILE_VERSION_ALL: 'mobile-version/all',
};
